import { modalContainerStyle } from '../data/store';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import React, { useEffect, useRef, MouseEvent } from 'react';
import { clearRVP, removeRVP, saveToStorage } from '../data/data-service';
import { cloneDeep } from 'lodash';

interface IRvpPopupPopup {
    popupType: string;
    setPopupType: (popupType: string) => void;
    setIsPopupOpened: (isPopupOpened: boolean) => void;
    popupSkuId: number;
    setPopupSkuId: (popupSkuId: number) => void;
    popupProductName: string;
    setPopupProductName: (popupProductName: string) => void;
    products: unknown[];
    setProducts: (products: unknown[]) => void;
    setAreProductsExist: (areProductExist: boolean) => void;
}

const RvpPopup = ({
                      popupType,
                      setIsPopupOpened,
                      setPopupType,
                      popupSkuId,
                      setPopupSkuId,
                      popupProductName,
                      setPopupProductName,
                      products,
                      setProducts,
                      setAreProductsExist,
}: IRvpPopupPopup) => {

    const delRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        delRef.current?.focus();
    }, []);

    const clearHistory = async () => {
        const response = await clearRVP();
        if (response && response.data.isValid) {
            setProducts([]);
            saveToStorage(null);
            setAreProductsExist(false);
        }
        else {
            console.log('Failed to Clear Products');
        }
        setIsPopupOpened(false);
        setPopupType('');
        setPopupSkuId(0);
        setPopupProductName('');
    };

    const removeProducts = async (skuid: number) => {
        const response = await removeRVP(skuid);
        if (response && response.data.isValid) {
            const copiedProducts = cloneDeep(products);
            const filteredProducts = copiedProducts.filter((product: any) => product.skuid !== skuid);
            setProducts(filteredProducts);
            if (filteredProducts.length === 0){
                setAreProductsExist(false);
            }
            saveToStorage(null);
        }
        else {
            console.log('Failed to Remove Product')
        }
        setIsPopupOpened(false);
        setPopupType('');
        setPopupSkuId(0);
        setPopupProductName('');
    };

    const onClick = async (evt: MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();

        if (popupType === 'clear-history') {
            await clearHistory();
        }

        if (popupType === 'remove-product') {
            await removeProducts(popupSkuId);
        }

        const title = popupType === 'clear-history' ? 'RVP-remove-all' : 'RVP-product-remove';
        const value = popupType === 'clear-history' ? 'RVP-remove-all' : popupProductName;
        sendGAEvent(title, value);
    };

    return (
        <div
            id="recently-viewed-products-are-you-sure-popup"
            className={ 'fixed w-72 h-36 flex items-center justify-center flex-col bg-white rounded absolute-center' }
            role="dialog"
            aria-labelledby="dialog-title"
            style={ modalContainerStyle }>

            <div
                id="dialog-title"
                className="mb-6 text-gray-700">Are you sure?</div>

            {/*<div id="dialog-description" className="sr-only">
                Lorem Ipsum
            </div>*/}

            <div className={'flex'}>
                <button
                    ref={ delRef }
                    type={"button"}
                    className="w-btn mt-2 mr-4"
                    onClick={ onClick }>Delete
                </button>

                <button
                    type={"button"}
                    className="w-btn mt-2"
                    style={{backgroundColor: 'gray'}}
                    onClick={evt => {
                        evt.preventDefault();
                        setIsPopupOpened(false);
                        setPopupType('');
                        setPopupSkuId(0);
                        setPopupProductName('');
                }}>Cancel</button>
            </div>
        </div>
    )
};

export default RvpPopup;